var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_55811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6862 5.83079L6.43619 5.81902C5.79186 5.81758 5.26836 6.33874 5.26692 6.98307L5.25515 12.2331C5.2537 12.8774 5.77487 13.4009 6.4192 13.4023L11.6692 13.4141C12.3135 13.4155 12.837 12.8944 12.8385 12.2501L12.8502 7.00007C12.8517 6.35574 12.3305 5.83223 11.6862 5.83079Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92831 9.31136L2.34498 9.31005C2.03556 9.30936 1.73909 9.18578 1.52079 8.96649C1.30249 8.74721 1.18024 8.45019 1.18093 8.14077L1.1927 2.89078C1.19339 2.58137 1.31697 2.2849 1.53625 2.06659C1.75554 1.84829 2.05256 1.72604 2.36198 1.72674L7.61196 1.7385C7.92138 1.7392 8.21785 1.86278 8.43615 2.08206C8.65445 2.30134 8.77671 2.59836 8.77601 2.90778L8.7747 3.49112",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_55811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.03125 0.554688) rotate(0.12843)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGrayIcon);
export default __webpack_public_path__ + "static/media/copy-gray-icon.7c0b1c8bd20107c7689ca1739e239911.svg";
export { ForwardRef as ReactComponent };